// Cloudflare Worker URL — update after deploying cloudflare-worker/attentive-proxy.js
const WORKER_URL = "https://attentive-proxy.jbeachhousegrp.workers.dev";
const ATTENTIVE_SIGN_UP_SOURCE_ID = "136874";

// Binds every signup form marked with [data-attentive-form] (footer + any
// section that renders the Attentive signup form), each scoped to itself.
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-attentive-form]").forEach(initAttentiveForm);
});

function initAttentiveForm(form) {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const emailElem = form.querySelector('input[name="contact[email]"]');
    const phoneElem = form.querySelector('input[name="contact[phone]"]');
    const email = emailElem ? emailElem.value.trim() : "";
    const phone = phoneElem ? phoneElem.value.trim() : "";
    const signUpFeedback = form.querySelector(".signup-feedback");

    clearErrors(form, emailElem, phoneElem);

    if (email === "" && phone === "") {
      showMessage(phoneElem || emailElem, "Please enter an email or phone number");
      return;
    }

    if (email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showMessage(emailElem, "Please enter a valid email address");
      return;
    }

    if (phone !== "" && !/^\+[0-9]{8,15}$/.test(phone)) {
      showMessage(phoneElem, "Please enter a valid US phone number including the +1 country code");
      return;
    }

    if (signUpFeedback) signUpFeedback.textContent = "Processing your subscription...";

    try {
      const body = { signUpSourceId: ATTENTIVE_SIGN_UP_SOURCE_ID, locale: "en-US" };
      if (email) body.email = email;
      if (phone) body.phone = phone;

      const response = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        if (signUpFeedback) signUpFeedback.textContent = "Thank you for subscribing!";
        form.reset();
      } else {
        const data = await response.json().catch(() => ({}));
        console.error("Attentive error:", data);
        if (signUpFeedback) signUpFeedback.textContent = "We couldn't complete your subscription. Please verify your information.";
      }
    } catch (err) {
      console.error("Network error:", err);
      if (signUpFeedback) signUpFeedback.textContent = "Unable to connect. Please try again.";
    }
  });
}

function clearErrors(form, email, phone) {
  form.querySelectorAll(".newsletter-form__message").forEach((el) => el.remove());
  if (email) email.classList.remove("has-error");
  if (phone) phone.classList.remove("has-error");
}

function showMessage(elem, msg) {
  if (!elem) return;
  elem.classList.add("has-error");
  elem.insertAdjacentHTML("afterend", `
    <small class="newsletter-form__message form__message">
      <svg style="background-color:#fff;border-radius:100%;" width="14" height="14" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 2V6" stroke="#E5001F"/>
        <circle cx="5" cy="7.5" r="0.5" fill="#E5001F"/>
      </svg>
      ${msg}
    </small>
  `);
}
